var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.980469,
    width: 98.0392,
    height: 100,
    rx: 49.0196,
    fill: "#425E88"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.3555 43.9875C66.6555 34.2844 59.0805 27 49.9805 27C42.7555 27 36.4805 31.6125 33.3555 38.3625C25.8305 39.2625 19.9805 46.4344 19.9805 55.125C19.9805 64.4344 26.7055 72 34.9805 72H67.4805C74.3805 72 79.9805 65.7 79.9805 57.9375C79.9805 50.5125 74.8555 44.4937 68.3555 43.9875ZM54.9805 52.3125V63.5625H44.9805V52.3125H37.4805L49.9805 38.25L62.4805 52.3125H54.9805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.7f0b48f4d0f0fac00a648a5d045d3edb.svg";
export { ForwardRef as ReactComponent };